<!--
作成者：本間
作成日：2020.10.01
画面名：棒グラフ(横)
機能：棒グラフ(横)
親子関係：
更新者：
①
更新内容：
①
-->
<script>
  import { HorizontalBar, mixins } from 'vue-chartjs';
  export default {
    extends: HorizontalBar,
    mixins: [mixins.reactiveData],
    props: ['data', 'options'],
    mounted() {
      this.chartData = this.data;
    },
    watch: {
      data: function() {
        this.chartData = this.data;
      },
    },
  };
</script>
